//@flow

import styled from "styled-components"

export const Background = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-align: center;
  background: linear-gradient(rgba(255, 255, 255, 1), rgba(0, 177, 236, 1));
  overflow: hidden;
`

export const Regions = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${props => props.zIndex || 0};
`
export const TitleRegion = styled.div`
  flex-grow: 1;
  flex-align: center;
  display: flex;
`

export const ActionRegion = styled.div`
  height: 248px;
  flex-basis: 248px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-align: center;
  display: flex;
`

export const Hero = styled.div`margin: auto auto;`

export const LocationName = styled.h1`
  font-family: "din-condensed";
  color: #0f2d49;
  font-weight: 400;
  font-size: 33px;
  border-top: 1px solid rgba(15, 45, 73, 1);
  border-bottom: 1px solid rgba(15, 45, 73, 1);
  padding: 10px 0;
  text-align: center;
  max-width: 664px;
  text-transform: uppercase;
`

export const BeginButton = styled.button`
  border: none;
  background: linear-gradient(rgba(37, 190, 174, 1), rgba(37, 183, 168, 1));
  border-radius: 1rem;
  font-family: "din-condensed";
  font-size: 62px;
  font-weight: 400;
  color: #0f2d49;
  padding: 10px 40px;
  width: 538px;
  text-align: center;
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.25);
  text-transform: uppercase;
  margin: 0 auto auto auto;
`
export const HomeContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: ${props => props.zIndex || 0};
`

export const Mountains = styled.div`
  position: absolute;
  bottom: -300px;
  height: 487px;
  width: 2513px;
  left: 50%;
  margin-left: -1256px;
  z-index: 2;
`

export const Sun = styled.div`
  position: absolute;
  z-index: 1;
  height: 1080px;
  width: 1920px;
  bottom: 0;
  left: 0;
`

export const SolidBackground = styled.div`
  position: absolute;
  z-index: 0;
  height: 1080px;
  width: 1920px;
  background: #00b1ec;
`

export const Content = styled.div`
  flex-grow: 1;
  flex-direction: column;
  height: 590px;
  flex-basis: 590px;
  align-items: center;
  display: flex;
`

export const Title = styled.h1`
  color: #fff;
  font-size: 100px;
  font-family: "din-condensed";
  font-weight: 400;
  line-height: 0.875em;
  text-transform: uppercase;
  margin: 0 auto;
  padding: 0;
  text-align: center;
`

export const EmphasizedTitle = Title.extend`
  color: #002943;
  font-size: 170px;
  font-weight: 600;
`

export const Description = styled.h2`
  color: #005890;
  font-family: "din-condensed";
  font-weight: 400;
  font-size: 36px;
  margin: 22px auto;
  text-align: center;
`

export const HeadingGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex-align: center;
  max-width: 1320px;
  margin: auto auto;
`



// WEBPACK FOOTER //
// ./src/Kiosk/AttractLoopView/UI.js